import { render } from "./Home.vue?vue&type=template&id=e7ff12a0&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=e7ff12a0&lang=scss&scoped=true"

import exportComponent from "H:\\Projects\\VueJs\\brand-command-landing-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7ff12a0"]])

export default __exports__